export default __webpack_public_path__ + "static/media/Arm_right.ccd2c216.svg";